<p>
  safety-observations-view-incidents works!
</p>
